import React, { Component } from 'react'
import { observable, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import Button from '../../UniformComponents/Button'
import CKeditor5 from '../CKeditor5'
import PanelAccordion from '../PanelAccordion'

import './styles/defaultPage.scss'
import { trackBuilderPageMenuAction } from '../../utils/MixpanelManager'

@observer
export default class ScreeningExitPage extends Component {
    @observable show = true

    @observable saveState = ''

    constructor(props) {
        super(props)
        makeObservable(this)
    }

    toggleShow = () => {
        this.show = !this.show
    }

    savePage = () => {
        const that = this
        const { page, store } = this.props
        const { survey } = store

        if (store.survey.closed) {
            return
        }

        const langCode = store.surveyLocale
        const content = {
            locale: langCode,
            text: page.content.get(langCode).text,
            redirectUrlSettings: page.redirectUrlSettings
        }

        const redirectUrl = R.pathOr(null, ['redirectUrlSettings', 'redirectUrl'], page)

        if (!R.isNil(redirectUrl) && !R.isEmpty(redirectUrl)) {
            if (!page.redirectUrlSettings.redirectUrl.match(/http[s]?:\/\//)) {
                store.handleError({ body: 'Invalid redirect URL. Missing http:// or https://', level: 'error' })
                that.saveState = 'failed'
                return
            }
        }

        store.http.put(`/api/survey/${survey.id}/page/${page.id}/content`, JSON.stringify(content), store.surveyToken)
            .then((response) => {
                const state = response.match(/updated/) ? 'saved' : 'failed'
                if (state === 'saved') {
                    store.addNotification({ body: 'Exit page saved', level: 'success' })
                } else {
                    store.handleError({ body: 'Error saving exit page', level: 'error' })
                }
                that.saveState = state
            })
            .catch((e) => {
                console.log(e)
                store.handleError({ body: e.message, level: 'error' })
                that.saveState = 'failed'
            })
    }

    handleEditorChange = (value) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }

        const langCode = store.surveyLocale
        page.content.get(langCode).text = value
    }

    removePage = (e) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }

        store.pageToDeleteId = page.id
        store.pageToDeleteType = 'EX'
        store.pageDeleteConfirm = true
        e.preventDefault()
    }

    updateTitle = (e) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }

        page.title = e.target.value
        page.update()
    }

    getContent = () => {
        const { page, store } = this.props
        const { survey } = store
        const langCode = store.surveyLocale

        if (!page.content.has(langCode)) {
            const text = page.content.has(survey.metadata.defaultLocale) ? page.content.get(survey.metadata.defaultLocale).text : ''
            page.content.set(langCode, {
                text,
            })
        }

        return page.content.get(langCode).text
    }

    previewPage = () => {
        const { page, store } = this.props
        trackBuilderPageMenuAction(store, { action: 'preview page' })
        let link = store.survey.getPreviewLink(true, store.useLatestUI, store.surveyLocale)
        link += `&pageId=${page.id}`
        store.gotoExternal(link)
    }

    dataViewerLink = () => {
        const { page } = this.props
        return (
            <a className="redlink" target='_blank' href={'/intranet/dataviewer?schema=explori_v3&tablename=survey_page_question&f1=surveyPageId&op1=eq&val1='+ page.id + '&viewdata=true'}>
                {page.id}
            </a>
        )
    }

    removeRedirect = () => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }

        page.redirectUrlSettings = {}
        trackBuilderPageMenuAction(store, { action: 'remove redirect url' })
        this.savePage()
    }

    updateRedirectUrl = ({ value }) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }
        trackBuilderPageMenuAction(store, { action: 'update redirect url' })
        page.redirectUrlSettings.redirectUrl = value.trim()
    }

    updateDelayMs = ({ value }) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }
        trackBuilderPageMenuAction(store, { action: 'update redirect delay', value: parseInt(value, 10) })
        page.redirectUrlSettings.delayRedirectSec = parseInt(value, 10)
    }

    render() {
        const { page_id, page, store } = this.props
        const { survey, userData } = store
        const canEdit = userData.role <= 140
        const key = `${page_id} tinymce`
        const content = this.getContent()

        return (
            <PanelAccordion
                title={`${i18n.t('s_page')} ${page.priority}`}
                subtitle={page.title}
                show={this.show}
                toggle={this.toggleShow}
                options="exit"
                updateURL={this.updateRedirectUrl}
                updateDelay={this.updateDelayMs}
                preview={this.previewPage}
                save={this.savePage}
                page={page}
                canEdit={canEdit}
                setPageLabel={({ value }) => store.setPageLabel(page, value)}
                remove={this.removePage}
                removeRedirect={this.removeRedirect}
                disabled={survey.closed}
            >
                <div className="page-accordion-content">
                    {store.showIds
                        && <span style={{ marginLeft: '5px' }}>{this.dataViewerLink()}</span>}

                    <CKeditor5
                        activeClass="p10"
                        toolbar="surveyExit"
                        key={key}
                        store={store}
                        data={content}
                        onBlur={this.handleEditorChange}
                        config={{
                            mergeFields: store.mergeFields,
                        }}
                    />

                    <br />

                    <Button
                        cssClass="regular primary pull-right"
                        onClick={this.savePage}
                        label={i18n.t('save')}
                        disabled={survey.closed}
                    />
                </div>
            </PanelAccordion>
        )
    }
}
